import React, { Component } from 'react';

import ForgotComponent from '../components/forgotPassword';

export default class ForgotPassword extends Component {
    render() { 
        const {...props} = this.props
        return (
            <div className='login-root'>
                <div className='bg-login'>
                    <div className='img-inside'></div>
                </div>
                <ForgotComponent {...props} />
            </div>
        )
    }

}

